import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    title: PropTypes.string,
    limit: PropTypes.number,
    query: PropTypes.shape({}),
    internalType: PropTypes.string,
  },
  {
    isCarousel(ac) {
      return this.internalType(ac) === "Carousel";
    },

    isList(ac) {
      return this.internalType(ac) === "List";
    },

    isMosaic(ac) {
      return this.internalType(ac) === "Mosaic";
    },

    queryTerm(ac) {
      return ac?.query?.query;
    },
  },
);
